<template>
    <div
        class="content-wrapper pl-3 pr-3 pb-3 pt-3 mb-2"
        style="height: inherit; width: inherit"
    >
        <!-- Content Header (Page header) -->
        <div v-if="$gate.isServiceAdmin()">
            <!-- Whatever VUE CONTENT: PLACE IT AFTER THIS COMMENT -->

            <section class="content-header">
                <div class="container-fluid">
                    <div class="row mb-2">
                        <div class="col-sm-6">
                            <h2>Customers | Master</h2>
                        </div>
                        <div class="col-sm-6">
                            <ol class="breadcrumb float-sm-right">
                                <li class="breadcrumb-item">
                                    <a href="/home">Home</a>
                                </li>
                                <li class="breadcrumb-item active">
                                    {{ $route.meta.title }}
                                </li>
                            </ol>
                        </div>
                    </div>
                </div>
                <!-- /.container-fluid -->
            </section>

            <!-- Main content -->
            <section class="content">
                <br />
                <!-- main row for all icons  -->
                <div class="col-lg-12">
                    <div class="card">
                        <div class="col-sm-12">
                            <div class="row">
                                <div class="col-sm-4">
                                    <div class="form-group">
                                        <span
                                            class="right badge badge-secondary"
                                            >Select From Date:</span
                                        >
                                        <input
                                            type="date"
                                            class="form-control"
                                            v-model="from"
                                            placeholder="Select from date"
                                        />
                                    </div>
                                </div>
                                <div class="col-sm-4">
                                    <div class="form-group">
                                        <span
                                            class="right badge badge-secondary"
                                            >Select To Date:</span
                                        >
                                        <input
                                            type="date"
                                            class="form-control"
                                            v-model="to"
                                            placeholder="Select to date"
                                        />
                                    </div>
                                </div>
                                <div class="col-sm-4">
                                    <div class="form-group">
                                        <span
                                            class="right badge badge-secondary"
                                            >Search by Branch:</span
                                        >
                                        <v-select
                                            v-model="branch"
                                            class="form-control"
                                            type="text"
                                            label="branch"
                                            :options="branches"
                                            :reduce="
                                                (branches) =>
                                                    branches.branch_code
                                            "
                                            name="branch"
                                            placeholder="Select Branch"
                                            :value="
                                                (branches) =>
                                                    branches.branch_code
                                            "
                                        ></v-select>
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-sm-4">
                                    <div class="form-group float-left">
                                        <button
                                            class="btn btn-primary"
                                            @click="getGP"
                                        >
                                            <i class="fa fa-search"></i> Search
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="card card-danger card-outline">
                        <div class="card-header">
                            Net Profit | {{ from }} - {{ to }}
                        </div>
                        <div class="card-body overflow-auto">
                            <br /><br />
                            <div class="col-sm-12">
                                <div class="row">
                                    <div class="col-lg-4 col-6">
                                        <!-- small box -->
                                        <div class="small-box bg-danger">
                                            <div class="inner">
                                                <h3>{{ income }}</h3>
                                                <p>Gross Profit</p>
                                            </div>
                                            <div class="icon">
                                                <i
                                                    class="ion ion-stats-bars"
                                                ></i>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="col-lg-4 col-6">
                                        <!-- small box -->
                                        <div class="small-box bg-danger">
                                            <div class="inner">
                                                <h3>{{ expense }}</h3>
                                                <p>Expense</p>
                                            </div>
                                            <div class="icon">
                                                <i class="ion ion-minus"></i>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="col-lg-4 col-6">
                                        <!-- small box -->
                                        <div class="small-box bg-danger">
                                            <div class="inner">
                                                <h3>{{ profit }}</h3>
                                                <p>Net Profit</p>
                                            </div>
                                            <div class="icon">
                                                <i class="ion ion-bag"></i>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <!-- row end -->
            </section>
            <!-- /.content -->

            <!-- All VUE Parts end before this comment -->
        </div>
        <div v-if="!$gate.isServiceAdmin()">
            <access-denied></access-denied>
        </div>
    </div>
</template>

<script>
export default {
    mounted() {
        console.log("Component mounted.");
    },

    created() {
        this.getBranches();
    },

    data() {
        return {
            from: "",
            to: "",
            expense: "",
            income: "",
            profit: "",
            branches: [],
            branch: "",
        };
    },

    methods: {
        getBranches() {
            axios.post("/api/getBranches").then((response) => {
                this.branches = response.data;
            });
        },

        getGP() {
            axios
                .post("/api/getGP", {
                    from: this.from,
                    to: this.to,
                    branch: this.branch,
                })
                .then((response) => {
                    this.expense = response.data.expense;
                    this.income = response.data.income;
                    this.profit = response.data.gp;
                });
        },
    },
};
</script>
